var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"banner"}},[_c('el-carousel',{attrs:{"autoplay":false,"indicator-position":"none","arrow":"never","height":_vm.bannerHeight + 'px',"width":_vm.bannerWidth + 'px'}},[_c('el-carousel-item',[_c('img',{ref:"bannerImg",staticStyle:{"width":"1920px","height":"750px"},attrs:{"src":_vm.url},on:{"load":_vm.imgLoad}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }